import Cherry1 from '../../../media/GW/Cherry Ville.webp'
import Cherry2 from '../../../media/GW/Cherry Ville.webp'


const Cherryimages =[
Cherry1,Cherry2
]

export default Cherryimages;